import { render } from "./unavailable-days.vue?vue&type=template&id=4c559173&scoped=true&ts=true"
import script from "./unavailable-days.vue?vue&type=script&lang=ts"
export * from "./unavailable-days.vue?vue&type=script&lang=ts"

import "./unavailable-days.vue?vue&type=style&index=0&id=4c559173&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c559173"]])

export default __exports__